module.exports = __webpack_public_path__ + "images/big-tipper-ff9996372aae24c8895afb415638cf13.png";